import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 16 13",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="m5.228 2.063.006-.029a2.6 2.6 0 0 1 .315-.823C5.935.566 6.684 0 8 0s2.065.566 2.451 1.21c.182.304.271.604.315.824l.006.029H14a1.5 1.5 0 0 1 1.5 1.5v7.5a1.5 1.5 0 0 1-1.5 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-7.5a1.5 1.5 0 0 1 1.5-1.5h3.228Zm4.384 0a1.408 1.408 0 0 0-.126-.274C9.31 1.496 8.934 1.125 8 1.125c-.934 0-1.31.371-1.486.664a1.408 1.408 0 0 0-.126.274h3.224Zm-7.987 1.5c0-.208.168-.376.375-.376h1.5v8.25H2a.375.375 0 0 1-.375-.374v-7.5Zm3 7.874h6.75v-8.25h-6.75v8.25Zm7.875 0v-8.25H14c.207 0 .375.168.375.376v7.5a.375.375 0 0 1-.375.374h-1.5Z"/>' }
  })
);